"use client";

import { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type FaqItem = {
  id: string;
  category: string;
  question: string;
  answer: string;
};
const faqs: FaqItem[] = [{
  id: "faq-1",
  category: "خدمات",
  question: "استودیو ARQ چه خدماتی در زمینه طراحی داخلی ارائه می‌دهد؟",
  answer: "ما در استودیو ARQ خدمات جامع طراحی داخلی شامل بازطراحی فضاهای مسکونی و تجاری، انتخاب متریال، نورپردازی هوشمند و نظارت بر اجرای پروژه را ارائه می‌دهیم. هر طرح با توجه به سبک زندگی و نیازهای خاص شما شخصی‌سازی می‌شود."
}, {
  id: "faq-2",
  category: "خدمات",
  question: "آیا امکان بازسازی فضاهای کوچک نیز وجود دارد؟",
  answer: "بله، تخصص ما در بهینه‌سازی فضاهای کوچک است. با استفاده از تکنیک‌های مدرن چیدمان و نورپردازی، فضاهای محدود را به محیط‌هایی دلباز، کاربردی و الهام‌بخش تبدیل می‌کنیم."
}, {
  id: "faq-3",
  category: "خدمات",
  question: "فرآیند طراحی در استودیو شما چگونه است؟",
  answer: "فرآیند ما شامل مشاوره اولیه، تحلیل فضا، ارائه کانسپت‌های اولیه، انتخاب متریال و در نهایت نظارت دقیق بر اجراست. ما در تمام مراحل همراه شما هستیم تا نتیجه نهایی دقیقاً مطابق با رویاهای شما باشد."
}, {
  id: "faq-4",
  category: "هزینه‌ها و قرارداد",
  question: "چگونه می‌توانم برآورد هزینه‌های پروژه را دریافت کنم؟",
  answer: "هزینه‌ها بسته به مقیاس و پیچیدگی پروژه متفاوت است. پس از جلسه مشاوره اولیه و بررسی نیازهای شما، یک پیشنهاد قیمت شفاف و دقیق برای تمامی مراحل طراحی و اجرا به شما ارائه خواهیم داد."
}, {
  id: "faq-5",
  category: "هزینه‌ها و قرارداد",
  question: "آیا برای پروژه‌ها قرارداد رسمی منعقد می‌شود؟",
  answer: "بله، تمامی پروژه‌های ما با قرارداد رسمی و شفاف آغاز می‌شوند که شامل جزئیات خدمات، زمان‌بندی دقیق و تعهدات طرفین است تا خیالتان از بابت کیفیت و زمان اجرا کاملاً راحت باشد."
}, {
  id: "faq-6",
  category: "همکاری",
  question: "چگونه می‌توانم برای مشاوره وقت بگیرم؟",
  answer: "شما می‌توانید از طریق فرم تماس در وب‌سایت یا شماره‌های درج شده در بخش گفتگو با ما، درخواست خود را ثبت کنید. تیم ما در کوتاه‌ترین زمان برای هماهنگی جلسه مشاوره با شما تماس خواهد گرفت."
}, {
  id: "faq-7",
  category: "همکاری",
  question: "آیا امکان بازدید حضوری از محل پروژه وجود دارد؟",
  answer: "بله، بازدید حضوری بخش مهمی از فرآیند طراحی ماست. این بازدید به ما کمک می‌کند تا پتانسیل‌های فضا، نور طبیعی و جزئیات معماری را بهتر درک کرده و طرحی دقیق‌تر ارائه دهیم."
}, {
  id: "faq-8",
  category: "همکاری",
  question: "سیاست لغو یا تغییر زمان جلسات چگونه است؟",
  answer: "ما برای زمان شما ارزش قائلیم. در صورت نیاز به تغییر زمان جلسه، لطفاً حداقل ۲۴ ساعت قبل به ما اطلاع دهید تا بتوانیم زمان دیگری را برای شما هماهنگ کنیم."
}, {
  id: "faq-9",
  category: "اجرا",
  question: "آیا نظارت بر اجرای پروژه توسط تیم شما انجام می‌شود؟",
  answer: "بله، نظارت بر اجرا یکی از ارکان اصلی خدمات ماست. ما اطمینان حاصل می‌کنیم که تمامی جزئیات طراحی با بالاترین کیفیت و مطابق با استانداردهای استودیو ARQ اجرا شوند."
}, {
  id: "faq-10",
  category: "اجرا",
  question: "مدت زمان اجرای یک پروژه چقدر است؟",
  answer: "زمان اجرا بستگی به ابعاد و جزئیات پروژه دارد. در مرحله برنامه‌ریزی، ما یک جدول زمانی دقیق به شما ارائه می‌دهیم و تمام تلاش خود را می‌کنیم تا پروژه در موعد مقرر با بهترین کیفیت تحویل داده شود."
}];
const groupedFaqs = faqs.reduce<{
  category: string;
  items: FaqItem[];
}[]>((acc, item) => {
  const last = acc[acc.length - 1];
  if (last && last.category === item.category) {
    last.items.push(item);
  } else {
    acc.push({
      category: item.category,
      items: [item]
    });
  }
  return acc;
}, []);
export default function Faq() {
  const [openId, setOpenId] = useState<string>("faq-1");
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const toggle = (id: string) => {
    setOpenId(prev => prev === id ? "" : id);
  };
  return <section data-section-id="434" id="سوالات-متداول" className="bg-background py-24 md:py-32 lg:py-[140px] text-foreground">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {}
          <div ref={leftRef} className={`lg:col-span-5 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="lg:sticky lg:top-28">
              <span className="font-default text-xs font-medium uppercase tracking-[0.2em] text-primary">
                سوالات متداول
              </span>
              <h2 className="mt-6 font-serif text-4xl leading-[1.1] tracking-tight text-foreground md:text-5xl lg:text-[3.25rem]">
                پرسش‌های{" "}
                <em className="font-serif italic text-foreground/90">
                  کلیدی،
                </em>{" "}
                پاسخ‌های شفاف.
              </h2>
              <p className="mt-6 max-w-md font-default text-base leading-relaxed text-muted-foreground">
                ما در استودیو ARQ معتقدیم که شفافیت، پایه و اساس یک همکاری موفق است. در اینجا به سوالاتی که اغلب مشتریان ما مطرح می‌کنند، پاسخ داده‌ایم.
              </p>

              <div className="mt-10 max-w-md border border-border p-8">
                <h3 className="font-serif text-xl text-foreground">
                  هنوز سوالی دارید؟
                </h3>
                <p className="mt-2 font-default text-sm leading-relaxed text-muted-foreground">
                  ما آماده شنیدن ایده‌های شما هستیم. با ما در تماس باشید تا به صورت شخصی به سوالات شما پاسخ دهیم.
                </p>
                <div className="mt-6">
                  <Link to="/TalkWithUsPage">
                    <Button variant="outline" className="border-primary bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground">
                      ارتباط با ما
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 transition-all duration-700 ease-out delay-100 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="flex flex-col gap-3">
              {groupedFaqs.map((group, gi) => <div data-index={gi} key={group.category} className="flex flex-col gap-3">
                  <span className="mt-6 px-2 font-default text-[11px] font-semibold uppercase tracking-[0.22em] text-secondary first:mt-0">
                    {group.category}
                  </span>

                  {group.items.map((item, i) => {
                const isOpen = openId === item.id;
                return <div data-index={i} key={item.id} className={`relative border-t border-border bg-card transition-all duration-300`}>
                        {isOpen && <span aria-hidden="true" className="absolute left-0 top-4 bottom-4 w-[3px] bg-primary" />}

                        <Button onClick={() => toggle(item.id)} aria-expanded={isOpen} aria-controls={`${item.id}-content`} variant="ghost" className="h-auto w-full justify-between gap-6 px-8 py-6 text-left font-normal">
                          <span className={`font-serif text-[19px] leading-snug text-foreground transition-all ${isOpen ? "font-medium" : "font-normal"}`}>
                            {item.question}
                          </span>

                          <span className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center border border-primary text-primary transition-transform duration-300 ease-out ${isOpen ? "rotate-45 bg-primary/10" : "rotate-0"}`}>
                            {isOpen ? <Minus className="h-4 w-4" strokeWidth={1.75} /> : <Plus className="h-4 w-4" strokeWidth={1.75} />}
                          </span>
                        </Button>

                        <div id={`${item.id}-content`} className={`grid overflow-hidden transition-all duration-200 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                          <div className="min-h-0">
                            <p className="max-w-[90%] px-8 pb-7 font-default text-[15px] leading-[1.65] text-muted-foreground">
                              {item.answer}
                            </p>
                          </div>
                        </div>
                      </div>;
              })}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}